import { Component, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { SharedService } from 'src/app/services/shared.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { UserService } from 'src/app/services/user.service';

@Component({
	selector: 'app-verify-phone',
	templateUrl: './verify-phone.component.html',
	styleUrls: ['./verify-phone.component.scss']
})
export class VerifyPhoneComponent implements OnInit {

	model = { nationalCode: "", mobile: "" };
	currentUser: any;




	verificationState: "NotStarted" | "Success" | "Failed" | "Pending" | "Error" = "NotStarted";

	constructor(private sharedService: SharedService, private userService: UserService, private spinner: SpinnerService) {
		sharedService.me$
			.pipe(takeUntil(this.unsubscribe$))
			.subscribe(async () => { this.loadUser(); });
	}

	loadUser() {
		this.currentUser = this.sharedService.me;
		if (!this.currentUser)
			return;
		else
			this.model.mobile = this.currentUser.Username;

	}

	ngOnInit(): void {
		// this.loadUser();


	}

	private unsubscribe$ = new Subject<void>();
	ngOnDestroy() {
		this.unsubscribe$.next();
		this.unsubscribe$.complete();
	}

	async checkPhoneAndNationalCode() {
		this.spinner.show("verify-phone");
		try {
			// console.log(this.model);
			this.verificationState = "Pending";
			let result = await this.userService.verifyPhone(this.model.mobile, this.model.nationalCode);
			// console.log(result);
			if (result) {
				this.verificationState = "Success";
			}
			else {
				this.verificationState = "Failed";
			}
		}
		catch {
			this.verificationState = "Error";
			console.log("error");
		}
		this.spinner.hide("verify-phone");
	}


}
